import React, {useContext} from 'react'
import {ApiServiceContext, PreloaderContext} from '../context'

const withApiService = mapMethodsToProps => Wrapped => {

  return (props) => {
    const
      serviceProps = mapMethodsToProps(useContext(ApiServiceContext)),
      setPreloaderState = useContext(PreloaderContext);

    return (
      <Wrapped {...props} {...serviceProps} setPreloaderState={setPreloaderState}/>
    );
  }
};

export default withApiService
